const Commands = ["approvepm", "approverm", "save", "submit", "recall", "rejectpm", "rejectrm"] as const;
type Command = (typeof Commands)[number];

export { Commands };
export type { Command };
